import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useDeleteFinanceAccount } from "@/features/accounts/finance/hooks/use-delete-accounts";
import { useDeleteCrecaAccount } from "@/features/accounts/creca/hooks/use-delete-accounts";
import { useDeletePaymentAccounts } from "@/features/accounts/payment/scraping/hooks/use-delete-accounts";
import { useDeleteEcshopAccounts } from "@/features/accounts/ecshop/hooks/use-delete-accounts";
import { useDeleteCsvExcelAccount } from "@/features/accounts/csv-excel/hooks/use-delete-accounts";
import { useDeleteOcrAccounts } from "@/features/accounts/ocr/hooks/use-delete-accounts";
import { useDeleteScrapFinanceAccount } from "@/features/accounts/scrap-finance/hooks/use-delete-accounts";

interface Props {
  accountGroupId: string;
  mlinkAccountId: string;
  mlinkId: string;
  passbookType: string;
  onTapCompleteModal: () => void;
  onTapCloseModal: () => void;
}

// 口座削除モーダル
export const DeleteAccountModal= ({
  accountGroupId,
  mlinkAccountId,
  mlinkId,
  passbookType,
  onTapCompleteModal,
  onTapCloseModal
}: Props) => {
  const { deleteFinanceAccounts } = useDeleteFinanceAccount();
  const { deleteCrecaAccounts } = useDeleteCrecaAccount();
  const { deletePaymentAccounts } = useDeletePaymentAccounts();
  const { deleteEcshopAccounts } = useDeleteEcshopAccounts();
  const { deleteCsvExcelAccounts } = useDeleteCsvExcelAccount();
  const { deleteOcrAccounts } = useDeleteOcrAccounts();
  const { deleteScrapFinanceAccounts } = useDeleteScrapFinanceAccount();

  const onClickDelete = async (
    accountGroupId: string,
    mlinkAccountId: string,
    mlinkId: string,
    passbookType: string,
  ) => {
    // 各API関数は errorHandledAsync でラップしているため，エラー時は undefined を返すことで処理を中断できる
    let result: unknown;
    if (passbookType === "01") {
      result = await deleteFinanceAccounts(accountGroupId, mlinkAccountId, mlinkId);
    } else if (passbookType === "09") {
      result = await deleteScrapFinanceAccounts(accountGroupId, mlinkAccountId, mlinkId);
    } else if (passbookType === "19659" || passbookType === "19660") {
      result = await deleteCrecaAccounts(accountGroupId, mlinkAccountId);
    } else if (passbookType === "03" || passbookType === "10") {
      result = await deletePaymentAccounts(accountGroupId, mlinkAccountId, mlinkId);
    } else if (passbookType === "20") {
      result = await deleteEcshopAccounts(accountGroupId, mlinkAccountId);
    } else if (passbookType === "201" || passbookType === "202") {
      result = await deleteCsvExcelAccounts(accountGroupId, mlinkAccountId);
    } else if (passbookType === "101") {
      result = await deleteOcrAccounts(accountGroupId, mlinkAccountId);
    }

    // エラー時（undefined）は処理を中断、ダイアログは各フックで表示済み
    if (result === undefined) {
      return;
    }
    onTapCompleteModal();
  };

    // 削除ボタンに付与するID
  const deleteAccountButton = "delete_account_button";

  return (
    <BasePageModal
      title="Web明細帳を削除"
      className="md-list-delete"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="Web明細帳を削除する"
          onClick={() => onClickDelete(accountGroupId, mlinkAccountId, mlinkId, passbookType)}
          id={deleteAccountButton}
          loadingNegative={true}
        />
      }
    >
      <h2>本当に削除しますか？</h2>
      <p>削除されたWeb明細帳を復元する事は出来ません</p>
    </BasePageModal>
  );
};
